import { Topping } from '../interfaces/IceCreamTypes'

export function isSprinkle(topping: Topping) {
    switch (topping) {
        case Topping.RaspberrySprinkles:
        case Topping.ChocolateSprinkles:
        case Topping.SaltedCaramelCookies:
        case Topping.SaltLicoriceFlakes:
        case Topping.NutKrokant:
        case Topping.PeppermintCandyCane:
        case Topping.FruitSprinkles:
        case Topping.PopcornCrunch:
            return true
        case Topping.Salmberry:
        case Topping.ChocolateSauce:
        case Topping.CaramelSauce:
        case Topping.Lemoncurd:
        case Topping.RaspberrySauce:
        case Topping.SaltLakrits:
        case Topping.Nougat:
            return false
        default:
            return false
    }
}
